import { Component, Injectable } from '@angular/core';

@Component({
  selector: 'app-expired-create-account',
  templateUrl: './expired-create-account.component.html',
  styleUrls: ['./expired-create-account.component.scss'],
  standalone: false
})
@Injectable()
export class ExpiredCreateAccountComponent {}
